import axios from 'axios';
import { Dispatch } from 'redux';

// Action Types
const GET_CURRENCIES = 'GET_CURRENCIES';
const SET_SELECTED_CURRENCY = 'SET_SELECTED_CURRENCY';

// Action Interfaces
interface GetCurrenciesAction {
  type: typeof GET_CURRENCIES;
  payload: Currency[];
}

interface SetSelectedCurrencyAction {
  type: typeof SET_SELECTED_CURRENCY;
  payload: string;
}

type CurrencyActions = GetCurrenciesAction | SetSelectedCurrencyAction;

// State Type
interface Currency {
    code: string;
    name: string;
    symbol: string;
    activated: boolean;
    createdAt: string;
    updatedAt: string;
}

interface CurrenciesState {
  currencies: Currency[];
  selectedCurrency: string | null;
}

// Initial State
const initialState: CurrenciesState = {
  currencies: [],
  selectedCurrency: 'EUR',
};

// Reducer
const currenciesReducer = (state: CurrenciesState = initialState, action: CurrencyActions): CurrenciesState => {
  switch (action.type) {
    case GET_CURRENCIES:
      return {
        ...state,
        currencies: action.payload,
      };
    case SET_SELECTED_CURRENCY:
      return {
        ...state,
        selectedCurrency: action.payload,
      };
    default:
      return state;
  }
};

// Action Creators
export const getCurrencies = () => async (dispatch: Dispatch<GetCurrenciesAction>) => {
  try {
    const response = await axios.get(`${process.env.NEXT_PUBLIC_SOCKET}/api/currencies`);
    dispatch({
      type: GET_CURRENCIES,
      payload: response.data,
    });
  } catch (error) {
    console.error('Error fetching currencies:', error);
    // Handle the error
  }
};

export const setSelectedCurrency = (currency: string) => (dispatch: Dispatch<SetSelectedCurrencyAction>) => {
  dispatch({
    type: SET_SELECTED_CURRENCY,
    payload: currency,
  });
};

export default currenciesReducer;
